import {notification} from 'antd';
import React from 'react';

import ServerNotificationToast from '../../components/UserNotifications/ServerNotificationToast';

const MOBILE_NOTIFICATION_KEY = 'server-mobile-notification';

export const showMobileServerNotification = (item, onOpen) => {
    const close = () => notification.destroy(MOBILE_NOTIFICATION_KEY);

    notification.open({
        key: MOBILE_NOTIFICATION_KEY,
        className: 'server-notification-toast',
        placement: 'top',
        duration: 6,
        message: null,
        closable: false,
        description: (
            <ServerNotificationToast
                item={item}
                onClose={close}
                onOpen={() => {
                    close();
                    onOpen();
                }}
            />
        ),
    });
};
